import { addDays, nextMonday, format } from "date-fns";
import { Moon, ArrowRight, CalendarOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUpdateItem } from "@/hooks/useItems";
import { toast } from "sonner";
import type { Item } from "@/lib/types";

type Props = {
  item: Item;
  onDone: () => void;
};

export function SnoozeView({ item, onDone }: Props) {
  const updateItem = useUpdateItem();

  const snooze = (dateTarget: string | null, label: string, priority?: string) => {
    updateItem.mutate(
      {
        id: item.id,
        date_target: dateTarget,
        ...(priority ? { priority: priority as Item["priority"] } : {}),
      },
      {
        onSuccess: () => {
          toast(`Snoozed until ${label}`);
          onDone();
        },
      }
    );
  };

  const tomorrow = format(addDays(new Date(), 1), "yyyy-MM-dd");
  const nextWeek = format(nextMonday(new Date()), "yyyy-MM-dd");

  return (
    <div className="space-y-3">
      <h4 className="text-sm font-medium text-muted-foreground">Snooze until...</h4>
      <div className="grid grid-cols-3 gap-2">
        <Button
          variant="outline"
          className="flex flex-col items-center gap-1 h-auto py-3"
          onClick={() => snooze(tomorrow, "tomorrow")}
          disabled={updateItem.isPending}
        >
          <ArrowRight className="h-4 w-4" />
          <span className="text-xs">Tomorrow</span>
        </Button>
        <Button
          variant="outline"
          className="flex flex-col items-center gap-1 h-auto py-3"
          onClick={() => snooze(nextWeek, "next week")}
          disabled={updateItem.isPending}
        >
          <Moon className="h-4 w-4" />
          <span className="text-xs">Next Week</span>
        </Button>
        <Button
          variant="outline"
          className="flex flex-col items-center gap-1 h-auto py-3"
          onClick={() => snooze(null, "someday", "low")}
          disabled={updateItem.isPending}
        >
          <CalendarOff className="h-4 w-4" />
          <span className="text-xs">Someday</span>
        </Button>
      </div>
    </div>
  );
}
